<template>
    <div class="login-form p-4">
        <div class="form-header">
            <div class="d-flex justify-content-center header-logo">
                <img
                    class="sticky-img"
                    width="100"
                    src="../../assets/img/logo-daring.png"
                    alt="Logo"
                />
            </div>
        </div>
        <div v-if="!forgotPasswordForm">
            <div class="form-body py-4">
                <div role="group">
                    <label for="input-email">Email</label>
                    <b-form-input
                        id="input-email"
                        class="form-login"
                        name="email"
                        data-vv-as="Email"
                        v-model="login_form.email"
                        type="email"
                        placeholder="Enter your email"
                        v-validate="'required|email'"
                        trim
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('email') }">{{ errors.first('email') }}</span>
                </div>
                <div role="group">
                    <label for="input-password">Password</label>
                    <b-input-group>
                        <b-form-input
                            id="input-password"
                            class="form-login"
                            name="password"
                            data-vv-as="Password"
                            v-model="login_form.password"
                            :type="!login_form.showPassword ? 'password' : 'text'"
                            placeholder="Enter your password"
                            v-validate="'required'"
                            trim
                        >
                        </b-form-input>
                        <b-input-group-append @click="login_form.showPassword = !login_form.showPassword" style="cursor: pointer;">
                            <b-input-group-text>
                                <b-icon :icon="login_form.showPassword ? 'eye-slash' : 'eye'" />
                            </b-input-group-text>
                        </b-input-group-append>
                    </b-input-group>
                    <span :class="{ 'error-validation': errors.first('password') }">{{ errors.first('password') }}</span>
                </div>
                <div role="group" class="my-2 text-right">
                    <a href="javascript:void(0)" @click="showForgotPasswordForm()">Lupa kata sandi anda ?</a>
                </div>
            </div>
            <div class="form-footer">
                <div v-if="showLoader">
                    <div class="text-center text-danger my-2">
                        <img class="img-loading" src="../../assets/img/logo-daring.png" alt="Logo"/><br>
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                    <!-- <square-loader :loading="showLoader" :color="'#ca062a'" :size="'40px'"></square-loader> -->
                </div>
                <div v-else class="row py-2">
                    <div class="col-6">
                        <b-button variant="primary" size="md" style="width: 100%;" @click.prevent="login">MASUK</b-button>
                    </div>
                    <div class="col-6">
                        <b-button variant="outline-danger" size="md" style="width: 100%;" @click="hideModalLogin">BATAL</b-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="forgot-password-form">
                <div class="form-body py-4">
                    <div class="header-form text-center">
                        <h6>Atur Ulang Kata Sandi</h6>
                    </div>
                    <div class="body-form">
                        <b-form data-vv-scope="forgot-password-form">
                            <b-form-input
                                id="input-forgot-email"
                                class="form-forgot-email"
                                name="email"
                                data-vv-as="Email"
                                v-model="forgot_password_form.email"
                                type="text"
                                placeholder="Masukan Email"
                                v-validate="'required|email'"
                                trim
                            ></b-form-input>
                            <span :class="{ 'error-validation': errors.first('forgot-password-form.email') }">{{ errors.first('forgot-password-form.email') }}</span>
                        </b-form>
                    </div>
                </div>
                <div class="form-footer">
                    <div v-if="showLoader">
                        <div class="text-center text-danger my-2">
                            <img class="img-loading" src="../../assets/img/logo-daring.png" alt="Logo"/><br>
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </div>
                    <div v-else class="row py-2">
                        <div class="col-6">
                            <b-button variant="primary" size="md" style="width: 100%;" @click.prevent="sendEmailForgotPassword">KIRIM</b-button>
                        </div>
                        <div class="col-6">
                            <b-button variant="outline-danger" size="md" style="width: 100%;" @click="hideForgotPasswordForm()">KEMBALI</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { EventBus } from '@/eventBus.js'
    // import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
	export default {
		components: {
            // SquareLoader
		},
		data() {
			return {
				login_form: {
					email: null,
					password: null,
					remember_me: false,
                    type: 'murid',
                    showPassword: false
				},
				showLoader: false,
				forgotPasswordForm: false,
                forgot_password_form: {
                    email: null
                }
			}
		},
		methods: {
            showForgotPasswordForm() {
                this.forgotPasswordForm = true
            },
            hideForgotPasswordForm() {
                this.forgotPasswordForm = false
            },
            sendEmailForgotPassword() {
                let scope = 'forgot-password-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.showLoader = true
                        let form = this.forgot_password_form
                        this.$store.dispatch('forgotPassword', form)
                            .then((res) => {
                                this.showLoader = false
                                this.hideModalLogin()
                                this.$swal.fire('Success', res.message, 'success')
                            })
                            .catch((err)=> {
                                let error = err.response
                                this.showLoader = false
                                if (error.status == 400) {
                                    this.errorValidate(error.data, scope)
                                } else {
                                    this.$swal.fire('Failed', error.data.message, 'error')
                                }
                            })
                    }
                });
            },
			hideModalLogin() {
                EventBus.$emit('hideModalLogin', true)
			},
			login() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.showLoader = true
                        let email = this.login_form.email 
						let password = this.login_form.password
						let remember_me = this.login_form.remember_me
						let type = this.login_form.type
						this.$store.dispatch('login', { email, password, remember_me, type })
							.then(() => {
                                this.showLoader = false
                                this.$swal.fire('Success', 'Login success', 'success')
								// this.$router.push(this.$route.query.redirect || '/')
                                this.$router.replace('/dashboard')
							})
							.catch((err)=> {
                                let error = err.response
                                this.showLoader = false
                                if (error.status == 400) {
                                    this.errorValidate(error.data)
                                } else {
                                    this.$swal.fire('Failed', error.data.message, 'error')
                                }
							})
                    }
                });
			},
		}
  }
</script>